/**
 * VendedoresTopWidget — Top 5 vendedores por performance.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterPainel } from "../../../services/comercialPainel";

import { CardBody, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "vendedores_top",
  label: "Top vendedores",
  descricao: "Top 5 vendedores por valor aprovado no periodo.",
  categoria: "Comercial",
  permissoes: ["comercial:metricas"],
  tamanho_default: "M",
  essencial: false,
};

export async function fetchData(request) {
  return await obterPainel(request);
}

function fmt(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
}

export function Widget({ dados }) {
  const top = Array.isArray(dados?.performance_vendedor)
    ? dados.performance_vendedor
    : Array.isArray(dados?.top_vendedores)
    ? dados.top_vendedores
    : [];
  if (top.length === 0) {
    return (
      <>
        <CardBody>
          <KpiSub>Sem dados de performance.</KpiSub>
        </CardBody>
        <CardFooter>
          <LinkLight as={Link} to="/comercial/painel">Ver painel</LinkLight>
        </CardFooter>
      </>
    );
  }
  return (
    <>
      <CardBody>
        <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 4 }}>
          {top.slice(0, 5).map((v, i) => (
            <li key={v.id || v.vendedor || i} style={{ display: "flex", justifyContent: "space-between", fontSize: "0.85rem" }}>
              <span>{v.nome || v.vendedor || `Vendedor ${i + 1}`}</span>
              <strong>{fmt(v.valor_aprovado ?? v.pipeline ?? v.total)}</strong>
            </li>
          ))}
        </ul>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/comercial/painel">Ver painel</LinkLight>
      </CardFooter>
    </>
  );
}
